import React from "react";
import { Link } from "react-router-dom";
import { journalEntries } from "../Datas/editorialData";
import siteConfig from "../config/siteConfig";
import "../css/editorial-pages.scss";
import { editorialImageSrcSet } from "../utils/images";
import useEditorialCollection from "../hooks/useEditorialCollection";
import EditorialCard from "./EditorialCard";
import EditorialFilters from "./EditorialFilters";
import PageMeta from "./PageMeta";

function Journal() {
  const {
    categories,
    currentCategory,
    filteredEntries,
    query,
    setCategory,
    setQuery,
  } = useEditorialCollection(journalEntries);

  return (
    <main className="content-page editorial-page journal-page">
      <PageMeta
        title="The pantry journal"
        description={`Kitchen rituals, maker-minded ingredient notes, and table stories from ${siteConfig.brandName}.`}
      />

      <header className="editorial-hero editorial-hero--journal">
        <div className="page-shell editorial-hero__grid">
          <div className="editorial-hero__copy">
            <p className="eyebrow">The {siteConfig.brandName} journal</p>
            <h1>Stories for a more delicious pantry.</h1>
            <p>
              Ingredient knowledge, useful rituals, and thoughtful ways to
              gather—written for cooks who like to know what is on the table.
            </p>
          </div>
          <div className="editorial-hero__image">
            <img
              src="/main/journal-kitchen.jpg"
              srcSet={editorialImageSrcSet("/main/journal-kitchen.jpg")}
              sizes="(max-width: 760px) 100vw, 50vw"
              alt="A cook writing recipe notes beside pasta, tomatoes, herbs, and olive oil"
              width="1536"
              height="1024"
              loading="eager"
            />
          </div>
        </div>
      </header>

      <section className="page-section page-shell editorial-listing" aria-labelledby="journal-list-title">
        <div className="section-heading editorial-listing__heading">
          <p className="eyebrow">From the kitchen</p>
          <h2 id="journal-list-title">Read at your own pace</h2>
        </div>

        <EditorialFilters
          categories={categories}
          currentCategory={currentCategory}
          query={query}
          resultCount={filteredEntries.length}
          onCategoryChange={setCategory}
          onSearch={setQuery}
        />

        {filteredEntries.length > 0 ? (
          <div className="editorial-card-grid">
            {filteredEntries.map((entry) => (
              <EditorialCard key={entry.id} entry={entry} type="journal" />
            ))}
          </div>
        ) : (
          <div className="editorial-empty" role="status">
            <p className="eyebrow">No note found</p>
            <h2>That search returned an empty shelf.</h2>
            <p>Clear the filters or begin with one of our practical recipes.</p>
            <Link className="button button--primary" to="/recipes">
              Browse recipes
            </Link>
          </div>
        )}
      </section>

      <section className="editorial-crosslink editorial-crosslink--yellow">
        <div className="page-shell editorial-crosslink__inner">
          <div>
            <p className="eyebrow">Put it into practice</p>
            <h2>Find tonight&apos;s reason to open a good jar.</h2>
          </div>
          <Link className="button button--primary" to="/recipes">
            Browse recipes
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Journal;
